import { Spinner, ZakekeLoading } from '../spinner';
import React from 'react';
import styled, { useTheme } from 'styled-components';

const Loader = ({ className }: { className?: string }) => {
    const theme = useTheme();
    return <>{theme.loadingType === 'spinner' ? <Spinner className={className} /> : <ZakekeLoading className={className} />}</>;
};

export default styled(Loader)``;
